import { assetRegisterExcelExport } from "routes/asset-register/controller/register-excel-export"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import { errorSnackbar } from "lib/snackbar/error-snackbar"

export async function downloadRegisterExcel({ registerId, registerName }) {
    try {
        const excelBase64 = await assetRegisterExcelExport(registerId)
        const fileName = createFileName(registerName)
        const a = document.createElement("a")
        a.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${excelBase64}`
        a.download = fileName
        a.click()
        successSnackbar(`${fileName} created`)
    } catch (e) {
        errorSnackbar("Could not download asset register")
    }
}

function createFileName(registerName) {
    const value = `${registerName || "asset-register"}`
        .split(/[^a-zA-Z0-9-_]+/)
        .join("-")
        .toLowerCase()
    const safeName = value || "asset-register"
    return `${safeName}.xlsx`
}
